<template>
  <NavView></NavView>
    <SideBar></SideBar>
<div class="container-fluid mb-5" >
    <!-- <h4 class="manage-boder">Manage Customer</h4>  -->
    <h6 class="manage-boder pt-2 font1 font-bold1 ps-1"> <router-link class="decoration" to="/mrate/index"> Manage Rating Type </router-link></h6>
    
    <br>
    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
      <input class="form-control me-2 width7" type="search" placeholder="Search" aria-label="Search">
      <router-link class="line1 btn btn-primary text-light border-radius0" to="/mrate/create"> Create Rating Type</router-link> 

    </div>
    <br>



<Table id=""  class="table table-hover">
  <thead>
    <tr>
      <th>ID</th>
      <th>Type</th>
     
     
      <th>Actions</th>
    </tr>
  </thead>
 
    
 
  <tbody>
   
    <!-- v-for="key in count" :key="key" -->
    <tr  >
      <th></th>
      
      <td ><span class="badge bg-success border-radius0">Active</span></td>
     <!--  <td ><span class="badge badge-danger border-radius0">Innactive</span></td> -->
     
      <td class="">
        <!-- <CButton  color="primary" size="sm" >view</CButton> -->
        <!-- <router-link :to="{ name: 'McustomerView', params:{ id : mcustomer.idCustomer} }" class=" btn btn-primary  btn-sm text-light " >View</router-link>  -->
        <div class="dropdown">
            <a class="btn btn-primary btn-sm dropdown-toggle border-radius0" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
              select
            </a>
          
            <ul class="dropdown-menu border1 " aria-labelledby="dropdownMenuLink">
             <!-- <li><router-link :to="{ name: 'McustomerView', params:{ id : mcustomer.idCustomer} }" class="dropdown-item text-light font-color1" >View</router-link>  </li> -->
             <!-- <li><a v-on:click="viewload(mcustomer.idCustomer)" class="dropdown-item text-light font-color1" >View</a>  </li> -->
              <!-- <li><a class="dropdown-item text-light font-color1" href="#">update</a></li> -->
              
              <li><a v-on:click="updateLoad()" class="dropdown-item text-light font-color1" >Update</a></li>
              <li><a class="dropdown-item text-light font-color1" href="#">Delete</a></li>
              <li><a class="dropdown-item text-light font-color1" href="#">Inactive</a></li>
            </ul>
          </div>
        
        
      </td>
    </tr>
    
    
  </tbody>
</Table>




</div>
<!-- <button v-on:click="loadData1()" type="" class="btn btn-danger" >press</button> -->
<!-- <form @submit.prevent="del()" class="" >
 <input type="text" v-model="user.id"  class="form-control" >
 <button  type="" class="btn btn-success" >delete</button>
 </form> -->

</template>

<script>
 //import {   CButton, } from '@coreui/vue';
 //import httpClient from '@/axios';
 //import axios from 'axios';
 import authService from '@/auth.service';
 import NavView from '../../components/NavView.vue'
  import SideBar from '../../components/SideBar.vue'



export default {
    components:{ 
      NavView,SideBar
    },

 
   

    data(){
    return{
      
      mcustomers:'',
      access_token:authService.isLoggedIn(),
     
     
        

      
  
     
    };
    },


   methods:{ 
    updateLoad(){
      this.$router.push('/mrate/update'); 
    }
   

}




};

</script>

<style scoped>
.button1{
  width: 10px !important;
}
.border1{
  border: none;
  background-color: #0d6efd;
}
.font-color1:hover{
  color: black !important;
  cursor: pointer;
}
.manage-boder{
  border-bottom: 1px solid #E9E9E3;
  border-top: 1px solid #E9E9E3;
}
.border-radius0{
      border-radius:0px !important ;
}
.font1{
      font-size: 13px !important;
   
    }
    .font-bold1{
      font-weight: bold;
    }
    .manage-boder{
    border-bottom: 2px solid #E9E9E3;
    border-top: 2px solid #E9E9E3;
    padding-bottom: 10px !important;
    padding-top: 10px !important;
    
    }
    .font1{
      font-size: 13px !important;
   
    }
    .font-bold1{
      font-weight: bold !important;
    }
    .colr1{
        color:#A5A5A3;
        
    }
    .decoration{
    text-decoration: none;
    color:#A5A5A3  ;
  }
  .width7{
    width: 250px;
  }

</style>